import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const containerStyles: BoxStyleProps = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "colorBackgroundPrimaryStronger",
    padding: "space40",
    paddingTop: "space40",
    paddingBottom: "space40",
    borderTopLeftRadius: "borderRadius20",
    borderTopRightRadius: "borderRadius20"
};

export const titleStyles: TextStyleProps = {
    color: "colorTextWeaker",
    fontSize: "fontSize40",
    fontWeight: "fontWeightBold",
    fontFamily: "fontFamilyText",
    paddingLeft: "space30"
};
// eslint-disable-next-line import/no-unused-modules
export const closeButtonStyles: BoxStyleProps = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "space10",
    borderRadius: "borderRadius20",
    backgroundColor: "colorBackgroundPrimary",
    borderColor: "colorBorderPrimary",
    boxShadow: "none",
    _hover: {
        backgroundColor: "colorBackgroundPrimaryWeak",
        borderColor: "colorBorderPrimaryWeak"
    }
};
